<!--Close icon is not in the modal header because header is optional-->
<i class="icon-close font-xl cursor-pointer"
   (click)="modal.close()">
</i>

<div class="modal-body position-relative">
  <label class="fw-bold mt-2 mb-0 font-xl"
         [translate]="'common.delivery.postCodeToSeeDeliveryOptions'"></label>
  <bakery-delivery-check
    class="d-block mt-3"
    [bakeryId]="bakeryId"
    [country]="country"
  ></bakery-delivery-check>
</div>
